module.exports = __webpack_public_path__ + "static/media/boat-img-28.59e87679.jpg";